export default __webpack_public_path__ + "theme.css";